import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/DashboardShell";
import { StatusPill } from "@/components/brand";
import api from "@/lib/api";

const FILTERS = [
  { key: "", label: "All" },
  { key: "created", label: "Unassigned" },
  { key: "assigned", label: "Assigned" },
  { key: "en_route", label: "In transit" },
  { key: "delivered", label: "Delivered" },
  { key: "exception", label: "Exception" },
];

export default function MerchantOrders() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");

  const load = useCallback(async () => {
    const { data } = await api.get("/deliveries", { params: filter ? { status: filter } : {} });
    setItems(data);
  }, [filter]);
  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <PageHeader index="03" eyebrow="Orders" title="Order tracking" />

      <div className="flex flex-wrap gap-2 mb-6">
        {FILTERS.map((f) => (
          <button key={f.key} onClick={() => setFilter(f.key)} data-testid={`order-filter-${f.key || "all"}`}
            className={`px-3.5 py-1.5 font-mono text-[11px] tracking-[0.1em] uppercase border transition-colors ${filter === f.key ? "bg-[#0a0a0a] text-white border-[#0a0a0a]" : "border-gray-300 text-gray-500 hover:border-[#0a0a0a]"}`}>
            {f.label}
          </button>
        ))}
      </div>

      <div className="border border-gray-200 divide-y divide-gray-200" data-testid="merchant-order-list">
        {items.length === 0 && <div className="px-5 py-10 text-center text-sm text-gray-400">No orders.</div>}
        {items.map((d) => (
          <Link key={d.id} to={`/merchant/orders/${d.id}`} className="flex items-center justify-between px-5 py-4 hover:bg-gray-50" data-testid={`order-row-${d.id}`}>
            <div className="min-w-0">
              <div className="flex items-center gap-3">
                <span className="font-mono text-[11px] text-gray-400">{d.id.slice(0, 8).toUpperCase()}</span>
                <StatusPill status={d.status} />
              </div>
              <div className="mt-1.5 text-sm text-[#0a0a0a] truncate">{d.pickup.address} → {d.dropoff.address}</div>
              <div className="text-xs text-gray-500">
                {d.driver_name ? `Driver · ${d.driver_name}` : "Awaiting assignment"} · ETA {new Date(d.window_end).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
              </div>
            </div>
            <span className="font-mono text-[11px] tracking-[0.14em] uppercase text-gray-400 ml-4">Open →</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
